import { baseClasses } from '@weatherbug/common';
import axios from 'axios';
const { PulseBaseProvider } = baseClasses;

const setActiveLocationUri = '/api/locations/active';
const getRecentSearchLocationsUri = '/api/favorite-locations/recent';
const getLocationFromLatLngUri = '/api/locations/latlng';
const createRecentSearchLocationUri = '/api/favorite-locations/recent';
const getStationsByIdUri = 'api/stations/byid';
const getStationsByLatLonUri = 'api/stations/bylatlon';

export class LocationProvider extends PulseBaseProvider {
    constructor(authId, secret, options, logger) {
        super(authId, secret, options, logger);
    }

    async setActiveLocation(location) {
        const queryParams = {};

        return await super.putData(queryParams, location, setActiveLocationUri, true, validateSetActiveLocation, false);
    }

    // No caching on this since we always want the most up to date results.
    async getRecentSearchLocations() {
        const response = await this.pulseApi.getData(getRecentSearchLocationsUri, {}, this.options.timeout, 'json', false);
        if (!response || !Array.isArray(response)) {
            throw new Error('GetSearchLocation response was invalid');
        }

        return response;
    }

    // No caching on this since we always want the most up to date results.
    async getLocationFromLatLng(lat, lng) {
        const queryParams = {
            lat,
            lng
        };
        const response = await this.pulseApi.getData(getLocationFromLatLngUri, queryParams, this.options.timeout, 'json', false);
        if (!response) {
            throw new Error('getLocationFromLatLng response was invalid');
        }

        return response;
    }

    async createRecentSearchLocation(location) {
        const queryParams = {};

        return await super.postData(queryParams, location, createRecentSearchLocationUri, true, validateRecentSearchCreation, false);
    }

    static async getStationById(providerId, stationId) {
        try {
            return await axios.get(getStationsByIdUri, 
                { params: {
                    providerId,
                    stationId
                }
                });
        } catch (error) {
            console.log(`Failed to get station for ${providerId}, ${stationId}.`, error);
        }
    }

    static async getStationByLatLon(latitude, longitude) {
        try {
            return await axios.get(getStationsByLatLonUri, 
                { params: {
                    latitude,
                    longitude
                }
                });
        } catch (error) {
            console.log(`Failed to get station by lat/lon for ${latitude}, ${longitude}.`, error);
        }
    }
}

function validateRecentSearchCreation(response) {
    return response && response.length > 0;
}

function validateSetActiveLocation(response) {
    return response?.Id && response?.Locality?.SlugName;
}
